<template>
  <div class="container-fluid pt-0 mt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <EditContact
      v-if="editContactModal"
      :show="editContactModal"
      :contact="editedContacts"
      v-on:closeEditContactModal="editContactModal = false"
      @showSuccessPopup="handleSuccessPopup"
    />

    <DeleteModal
      :show="showDelete"
      @close="closeDelete"
      :name="$t('contact')"
      @submit="doDelete"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
    />

    <add-dispatch-contact
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      @showSuccessPopup="handleSuccessPopup"
    />

    <div
      style="
        background-color: #fff;
        max-height: 40rem;
        overflow-y: auto;
        width: 100%;
        height: fit-content;
      "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div class="header d-flex justify-content-between align-items-center">
          <p>{{ $t("dropoff-text") }}</p>
          <TableSearch @handleSearch="handleSearch" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span
                        class="arrow"
                        :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                      ></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    :key="index"
                    v-for="(contact, index) in paginatedData"
                    class="user-row"
                    style="border-bottom: unset"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td>{{ contact.name }}</td>
                    <td>{{ contact.address }}</td>

                    <td>{{ contact.email }}</td>

                    <td>{{ contact.phoneNumber }}</td>
                    <td>
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          class="cursor-pointer"
                          @click="editcontact(contact)"
                        >
                          <IconEdit />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click="openDelete(contact.id)"
                        >
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "intro.js/introjs.css";

import AddDispatchContact from "../../views/Modals/AddDispatchContact.vue";
import EditContact from "../Modals/EditContact";
import IconEdit from "../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../components/Iconsvg/IconDeleteUser.vue";
import tableMixin from "../../mixins/tableMixinWithBackend";
import Pagination from "../../components/PaginationNew.vue";
import TableSearch from "../../components/TableSearch.vue";
import SuccessModal from "../Modals/SuccessModal.vue";
import DeleteModal from "../Modals/DeleteModal.vue";

export default {
  name: "DispatchContacts",
  components: {
    AddDispatchContact,
    Loading,
    EditContact,
    IconEdit,
    IconDelete,
    Pagination,
    TableSearch,
    SuccessModal,
    DeleteModal,
  },
  data() {
    return {
      isLoading: true,

      fullPage: true,
      Tag: "",
      editedContacts: [],
      editContactModal: false,
      showSuccessPopup: false,
      showDelete: false,
      dataTable: [],

      successMsg: "",
      successHeading: "",
    };
  },
  mounted() {
    this.fetchContacts(this.params);
  },
  mixins: [tableMixin],
  props: {
    showModal: Boolean,
    closeModal: Function,
  },
  computed: {
    ...mapGetters(["contacts", "meta"]),
    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("name"), "fullname"],
        [this.$t("address"), "address"],
        [this.$t("email"), "email"],
        [this.$t("phone-number"), "phonenumber"],
        [this.$t("action"), "column2"],
      ];
    },
  },
  methods: {
    ...mapActions([
      "getContacts",
      "addContacts",
      "editContact",
      "deleteContact",
    ]),
    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },
    editcontact(contactInfo) {
      console.log(contactInfo);
      this.editedContacts = [contactInfo];
      this.Tag = "";
      this.editContactModal = true;
      console.log(this.editedContact);
    },
    closeDelete() {
      this.id = "";
      this.showDelete = false;
    },
    openDelete(id) {
      this.showDelete = true;
      this.id = id;
    },
    doDelete() {
      this.isLoading = true;
      this.deleteContact(this.id).then(() => {
        this.getContacts();
        this.isLoading = false;
        this.showDelete = false;

        this.showSuccessPopup = true;

        this.successMsg = this.$t("deleted_contact_mssg");
        this.successHeading = this.$t("deleted_contact_heading");
      });
    },
    doSearch() {
      let params = {
        ...this.params,
        name: this.searchQuery,
      };
      this.fetchContacts(params);
    },
    fetchContacts(params) {
      this.isLoading = true;
      this.getContacts(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    contacts: {
      handler: function() {
        this.dataTable = this.contacts;
      },
      deep: true,
    },
    params() {
      this.fetchContacts(this.params);
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 1rem;
}

.header > p {
  font-size: 14px;
  font-weight: 700;
  line-height: 18.2px;
  color: rgba(64, 74, 87, 1);
  margin-top: 1rem;
}
</style>

<i18n>
  {
    "en": {
      "dropoff-text": "Drop off contact",
      "action": "Action",
      "email": "Email",
      "name": "Name",
      "phone-number": "Phone Number",
      "address": "Address"
    },
    "es": {
      "dropoff-text": "Contacto de entrega",
      "action": "Acción",
      "email": "Email",
      "phone-number": "Número de teléfono",
      "address": "Dirección",
      "name": "Nombre"
    },
    "fr": {
      "dropoff-text": "Contact de dépôt",
      "action": "Action",
      "email": "E-mail",
      "phone-number": "Numéro de téléphone",
      "address": "Adresse",
      "name": "Nom"
    },
    "sw": {
      "dropoff-text": "Wasiliana na mtumaji",
      "action": "Kitendo",
      "email": "Barua pepe",
      "phone-number": "Nambari ya simu",
      "address": "Anwani",
      "name": "Jina"
    }
  }
  </i18n>
